/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiIntegrationsDtoAdminPingPaymentDisbursementDto } from './WebApiIntegrationsDtoAdminPingPaymentDisbursementDto';
import {
    WebApiIntegrationsDtoAdminPingPaymentDisbursementDtoFromJSON,
    WebApiIntegrationsDtoAdminPingPaymentDisbursementDtoFromJSONTyped,
    WebApiIntegrationsDtoAdminPingPaymentDisbursementDtoToJSON,
} from './WebApiIntegrationsDtoAdminPingPaymentDisbursementDto';

/**
 * OneFront's Ping Payments payout report, built disbursement-first: every payout Ping made to
 * OneFront (the tenant) in the period, each broken down into the individual service-fee
 * settlements that make it up. Intended as a bookkeeping voucher — one disbursement ≈ one bank line.
 * @export
 * @interface WebApiIntegrationsDtoAdminPingPaymentFeeReportDto
 */
export interface WebApiIntegrationsDtoAdminPingPaymentFeeReportDto {
    /**
     * 
     * @type {Array<WebApiIntegrationsDtoAdminPingPaymentDisbursementDto>}
     * @memberof WebApiIntegrationsDtoAdminPingPaymentFeeReportDto
     */
    disbursements?: Array<WebApiIntegrationsDtoAdminPingPaymentDisbursementDto> | null;
    /**
     * 
     * @type {number}
     * @memberof WebApiIntegrationsDtoAdminPingPaymentFeeReportDto
     */
    totalAmount?: number;
    /**
     * 
     * @type {Date}
     * @memberof WebApiIntegrationsDtoAdminPingPaymentFeeReportDto
     */
    fromDate?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof WebApiIntegrationsDtoAdminPingPaymentFeeReportDto
     */
    toDate?: Date | null;
}

/**
 * Check if a given object implements the WebApiIntegrationsDtoAdminPingPaymentFeeReportDto interface.
 */
export function instanceOfWebApiIntegrationsDtoAdminPingPaymentFeeReportDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiIntegrationsDtoAdminPingPaymentFeeReportDtoFromJSON(json: any): WebApiIntegrationsDtoAdminPingPaymentFeeReportDto {
    return WebApiIntegrationsDtoAdminPingPaymentFeeReportDtoFromJSONTyped(json, false);
}

export function WebApiIntegrationsDtoAdminPingPaymentFeeReportDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiIntegrationsDtoAdminPingPaymentFeeReportDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'disbursements': !exists(json, 'disbursements') ? undefined : (json['disbursements'] === null ? null : (json['disbursements'] as Array<any>).map(WebApiIntegrationsDtoAdminPingPaymentDisbursementDtoFromJSON)),
        'totalAmount': !exists(json, 'totalAmount') ? undefined : json['totalAmount'],
        'fromDate': !exists(json, 'fromDate') ? undefined : (json['fromDate'] === null ? null : new Date(json['fromDate'])),
        'toDate': !exists(json, 'toDate') ? undefined : (json['toDate'] === null ? null : new Date(json['toDate'])),
    };
}

export function WebApiIntegrationsDtoAdminPingPaymentFeeReportDtoToJSON(value?: WebApiIntegrationsDtoAdminPingPaymentFeeReportDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'disbursements': value.disbursements === undefined ? undefined : (value.disbursements === null ? null : (value.disbursements as Array<any>).map(WebApiIntegrationsDtoAdminPingPaymentDisbursementDtoToJSON)),
        'totalAmount': value.totalAmount,
        'fromDate': value.fromDate === undefined ? undefined : (value.fromDate === null ? null : value.fromDate.toISOString()),
        'toDate': value.toDate === undefined ? undefined : (value.toDate === null ? null : value.toDate.toISOString()),
    };
}

